export default __webpack_public_path__ + "static/media/txt_timeout.72cfb822.png";